import DictionaryItem from "../../../model/dictionary/DictionaryItem";

/**
 * Fetch activity templates successful action.
 */
export const ACTIVITY_TEMPLATES_FETCHED = "ACTIVITY_TEMPLATES_FETCHED";
export type ACTIVITY_TEMPLATES_FETCHED = { activityTemplates: DictionaryItem[] }

/**
 * Fetch job activity templates successful action.
 */
export const JOB_ACTIVITY_TEMPLATES_FETCHED = "JOB_ACTIVITY_TEMPLATES_FETCHED";
export type JOB_ACTIVITY_TEMPLATES_FETCHED = { jobActivityTemplates: DictionaryItem[] }